// @flow
import { createSelector } from 'reselect';

import {
  selectCartProductOwner,
  selectCartReselleeID,
  selectCartTotal,
  selectRawProductsArray,
} from '@gandi/cart';

import { selectShopCurrent } from '../../modules/organization/selectors';

import type { FullState } from '../../types';

export const selectDomainOwnerId: FullState => string = createSelector(
  [
    // $FlowFixMe[incompatible-call]
    state => selectShopCurrent(state, true),
    selectCartReselleeID,
    selectCartProductOwner,
  ],
  (currentOrganization, cartReselleeId, cartProductOwner) => {
    const isReseller = currentOrganization?.reseller ?? false;
    const hasResellee =
      cartReselleeId && currentOrganization?.id !== cartReselleeId;

    let domainOwnerId = currentOrganization?.id;
    if (isReseller && hasResellee) {
      domainOwnerId = cartReselleeId;
    } else if (!isReseller && cartProductOwner) {
      domainOwnerId = cartProductOwner;
    }

    return domainOwnerId;
  },
);

/** returns `true` 
    when at least one product has its status to `pricing`
    and the cart total is zero
 */
export const selectIsPricing: (state: FullState) => boolean = createSelector(
  [selectRawProductsArray, selectCartTotal],
  (products, { beforeTaxes }) => {
    const oneProductIsPricing = products.some(
      ({ status }) => status === 'pricing',
    );
    return !beforeTaxes && oneProductIsPricing;
  },
);
